export default "__VITE_ASSET__CE61Pu58__"